// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__2M0Ht","text":"styles_text__RNHnz"};